import type { ReactNode } from 'react';

interface PageHeroProps {
  /** Icon displayed next to the eyebrow subtitle */
  icon: ReactNode;
  /** Small eyebrow text next to the icon (e.g. "Service personnalisé") */
  subtitle: string;
  /** Main page title — can contain JSX for coloured spans / em */
  title: ReactNode;
  /** Two-line supporting text shown below the title */
  description: string;
}

/**
 * Compact, left-aligned page header used on all inner pages.
 * Structure: icon + subtitle → title → description
 */
export function PageHero({ icon, subtitle, title, description }: PageHeroProps) {
  return (
    <section className="bg-surface-cream border-b border-border-subtle">
      <div className="container-page py-10 md:py-14 max-w-6xl">
        <div className="max-w-5xl">
          <span className="eyebrow text-ink-muted mb-4 inline-flex items-center gap-2">
            {icon}
            {subtitle}
          </span>
          <h1 className="font-display text-h2 md:text-display text-ink leading-[1.12] tracking-tight">
            {title}
          </h1>
          <p className="mt-5 text-base md:text-[1.05rem] text-ink-secondary leading-relaxed max-w-4xl">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}
